import {Injectable, InjectionToken} from "@angular/core";
import {IMetadataGroup} from "../../../../../dev/components/elad.forms2/interfaces/metadata";
import {IMetadataFlatTable} from "../../../../../dev/components/elad.forms2/interfaces/metadata/imetadata.flat.table";

export const FormContextToken = new InjectionToken<AbstractFormContext>('formContextToken');

@Injectable()
export abstract class AbstractFormContext {
	abstract get metadata():IMetadataGroup;
	abstract get flatMetadata():IMetadataFlatTable[];
	abstract get parentTableName():string;

	abstract get supportGroup():boolean;
	abstract get supportSpecialControls(): boolean;
	abstract get supportHideConditions():boolean;
	abstract get supportStoredSubForms():boolean;
	abstract get supportVirtualFields():boolean;
	abstract get supportReadonly():boolean;
}
